<template>
    <div class="box">
        <div class="field">
            <p class="title">Forgot Password</p>
        </div>
        <hr style="margin-left:25px;margin-right:25px;"/>

        <table>
            <tr>
                <td>
                    <b class="textlabel">Email</b>
                </td>
                <td style="width:100%">
                    <input id="email" class="textfield" type="email" v-model="email"></input>
                </td>
            </tr>
        </table>

        <div class="field">
            <button type="button" v-on:click="cancel()">Cancel</button>
            <button type="button" v-on:click="request()">Request Password Reset</button>
        </div>
    </div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
	data() {
		return {
			email: ''
		}
	},
	methods: {
        cancel (){
            router.push('/0200');
        },
        request (){
            api.postData(
                {
                    type:"login",
                    data:{
                        pageid:PAGES.FORGOT_PASSWORD_PAGE,
                        data:[
                            this.email
                        ]
                    }
                }
            ).then((res) => {
                if(res.data.errors.length>0) {
                    var message = '';
                    for(var i = 0;i<res.data.errors.length;i++){
                        message+="• "+res.data.errors[i]+'\n';
                    }
                    alert("𝗘𝗿𝗿𝗼𝗿\n\n"+message);
                }else{
                    alert("We have sent you an email to reset your password");
                }
	        });
        },
	}
}
</script>

<style scoped>
.box{
    margin-right: 25%;
    margin-left: 25%;
    margin-top: 55px;
    border: 3px solid #35495E;
    border-radius: 20px;
}

.field{
    padding:10px;
    text-align:center;
}

.textlabel{
    white-space:nowrap;
    color:#35495E;
}

.textfield{
    width:100%;
}

.title{
    font-size:30px;
    font-weight:bold;
    color:#35495E;
}

.smalltext{
    font-size: 12px;
	color: #888888;
}

button.link {
    background:none;
    border:none;
    color:#0066dd;
    text-decoration: underline;
}

table {
    table-layout:auto;
    margin:auto;
    width:75%;
    border: none;
}
td {
    border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/file/Forgot_Password.vue